var map = {
	"app/pages/crossChannel/clickCollect/clickCollect.module": [
		"./src/app/pages/crossChannel/clickCollect/clickCollect.module.ts",
		"app-pages-crossChannel-clickCollect-clickCollect-module"
	],
	"app/pages/crossChannel/clickCollect/shops/shops.module": [
		"./src/app/pages/crossChannel/clickCollect/shops/shops.module.ts",
		"app-pages-crossChannel-clickCollect-shops-shops-module"
	],
	"app/pages/crossChannel/crossChannel.module": [
		"./src/app/pages/crossChannel/crossChannel.module.ts",
		"app-pages-crossChannel-crossChannel-module"
	],
	"app/pages/crossChannel/digitalOffline/digitalOffline.module": [
		"./src/app/pages/crossChannel/digitalOffline/digitalOffline.module.ts",
		"app-pages-crossChannel-digitalOffline-digitalOffline-module"
	],
	"app/pages/crossChannel/digitalOffline/shops/shops.module": [
		"./src/app/pages/crossChannel/digitalOffline/shops/shops.module.ts",
		"app-pages-crossChannel-digitalOffline-shops-shops-module"
	],
	"app/pages/crossChannel/reservations/reservations.module": [
		"./src/app/pages/crossChannel/reservations/reservations.module.ts",
		"app-pages-crossChannel-reservations-reservations-module"
	],
	"app/pages/crossChannel/reservations/shops/shops.module": [
		"./src/app/pages/crossChannel/reservations/shops/shops.module.ts",
		"app-pages-crossChannel-reservations-shops-shops-module"
	],
	"app/pages/crossChannel/shipFromStore/shipFromStore.module": [
		"./src/app/pages/crossChannel/shipFromStore/shipFromStore.module.ts",
		"app-pages-crossChannel-shipFromStore-shipFromStore-module"
	],
	"app/pages/crossChannel/shipFromStore/shops/shops.module": [
		"./src/app/pages/crossChannel/shipFromStore/shops/shops.module.ts",
		"app-pages-crossChannel-shipFromStore-shops-shops-module"
	],
	"app/pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"app-pages-dashboard-dashboard-module"
	],
	"app/pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"app-pages-login-login-module"
	],
	"app/pages/management/integradorWST/integradorWST.module": [
		"./src/app/pages/management/integradorWST/integradorWST.module.ts",
		"app-pages-management-integradorWST-integradorWST-module~app-pages-management-shipFromStore-shipFromS~6f510a2f",
		"app-pages-management-integradorWST-integradorWST-module"
	],
	"app/pages/management/management.module": [
		"./src/app/pages/management/management.module.ts",
		"app-pages-management-management-module"
	],
	"app/pages/management/shipFromStore/shipFromStore.module": [
		"./src/app/pages/management/shipFromStore/shipFromStore.module.ts",
		"app-pages-management-integradorWST-integradorWST-module~app-pages-management-shipFromStore-shipFromS~6f510a2f",
		"app-pages-management-shipFromStore-shipFromStore-module"
	],
	"app/pages/management/shops/shops.module": [
		"./src/app/pages/management/shops/shops.module.ts",
		"app-pages-management-integradorWST-integradorWST-module~app-pages-management-shipFromStore-shipFromS~6f510a2f",
		"app-pages-management-shops-shops-module"
	],
	"app/pages/management/users/users.module": [
		"./src/app/pages/management/users/users.module.ts",
		"app-pages-management-integradorWST-integradorWST-module~app-pages-management-shipFromStore-shipFromS~6f510a2f",
		"app-pages-management-users-users-module"
	],
	"app/pages/register/register.module": [
		"./src/app/pages/register/register.module.ts",
		"app-pages-register-register-module"
	],
	"app/pages/stock/shops/shops.module": [
		"./src/app/pages/stock/shops/shops.module.ts",
		"app-pages-stock-shops-shops-module"
	],
	"app/pages/stock/shops/shops/shops.module": [
		"./src/app/pages/stock/shops/shops/shops.module.ts",
		"app-pages-stock-shops-shops-shops-module"
	],
	"app/pages/stock/stock.module": [
		"./src/app/pages/stock/stock.module.ts",
		"app-pages-stock-stock-module"
	],
	"app/pages/usage/shops/shops.module": [
		"./src/app/pages/usage/shops/shops.module.ts",
		"app-pages-usage-shops-shops-module"
	],
	"app/pages/usage/usage.module": [
		"./src/app/pages/usage/usage.module.ts",
		"app-pages-usage-usage-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;